import { PlaceData } from "../../shared/data/types";

interface FetchProps {
  sendRequest: (
    url: string,
    method?: string,
    body?: BodyInit,
    headers?: HeadersInit,
    successMessage?: boolean,
    zeroResultsKey?: string
  ) => Promise<any>;
}

// FETCH PLACES ////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
interface FetchPlacesProps extends FetchProps {
  setLoadedPlaces: React.Dispatch<React.SetStateAction<PlaceData[]>>;
}

export const fetchPlaces = async (props: FetchPlacesProps) => {
  const { sendRequest, setLoadedPlaces } = props;

  const places: { places: PlaceData[] } = JSON.parse(
    localStorage.getItem("places-v8")
  );
  const placesIncludeLasChange = places?.places
    ?.map((place) => {
      return place?.name;
    })
    ?.includes("CAMPO GRANDE - RN");
  if (
    !places ||
    !places?.places ||
    places?.places?.length === 0 ||
    !places?.places?.[0]?.name ||
    !placesIncludeLasChange
  ) {
    const fetchPlaces = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/places/unauth`,
          "GET",
          null,
          {}
        );
        localStorage.setItem(
          "places-v8",
          JSON.stringify({
            places: responseData.places,
          })
        );
        setLoadedPlaces(responseData.places);
      } catch (err) {}
    };
    fetchPlaces();
  } else if (
    places &&
    places?.places &&
    places?.places?.length > 0 &&
    !!places?.places?.[0]?.name
  ) {
    setLoadedPlaces(places.places);
  }
};
